import TicketList from './ticketList.module';
import Picker from './picker.module';
import PickerTopBar from './pickerTopBar.module';
import LabelSettings from './labelSettings.module';
import BulkSwapSeats from './bulkSwapSeats.module';

export default {
    namespaced: true,
    modules: {
        TicketList,
        Picker,
        PickerTopBar,
        LabelSettings,
        BulkSwapSeats,
    },
};
